import { NumericFormat } from "react-number-format";

import { type CurrencyLocale, round } from "@btnet/utilities-core";

import { TextTruncate } from "../TextTruncate/TextTruncate";
import "./NumberDisplay.less";

interface INumberDisplayProps {
  value: number;
  "data-testid"?: string;
  decimalScale?: number;
  suffix?: string | undefined;
  shouldTruncate?: boolean;
  currencyLocale: CurrencyLocale;
}

export function NumberDisplay({
  value,
  "data-testid": testid,
  decimalScale = 2,
  suffix,
  shouldTruncate,
  currencyLocale,
}: INumberDisplayProps) {
  const roundedValue = round(value, decimalScale);

  const formatted = (
    <NumericFormat
      value={roundedValue}
      displayType="text"
      decimalScale={decimalScale}
      fixedDecimalScale
      thousandSeparator={currencyLocale.groupSeparator}
      decimalSeparator={currencyLocale.decimalSeparator}
      {...(currencyLocale.thousandsGroupStyle !== undefined && {
        thousandsGroupStyle: currencyLocale.thousandsGroupStyle,
      })}
      {...(suffix !== undefined && { suffix })}
      dir="ltr"
      data-testid={testid}
    />
  );

  if (!shouldTruncate) return formatted;

  return <TextTruncate>{formatted}</TextTruncate>;
}
